const ValuesSection = () => {
  const values = [
    {
      title: 'Excellence',
      description:
        'Kami percaya setiap orang punya potensi untuk menjadi versi terbaiknya. Itulah mengapa kami hadir untuk membimbingmu mencapai standar global, agar kamu tidak hanya lolos, tapi juga bersinar di dunia kerja profesional Jepang.',
    },
    {
      title: 'Care',
      description: (
        <>
          Kami peduli pada proses belajarmu. Bukan hanya soal skill, tapi juga
          semangat dan ketahananmu menghadapi tantangan menuju karier
          internasional.
          <br />
          <span className="font-bold text-[#d91f2d]">
            "Suksesmu adalah misi kami"
          </span>
        </>
      ),
    },
    {
      title: 'Growth Mindset',
      description:
        'Kami percaya kemampuan bisa diasah dan masa depan bisa dikejar. Kamu tidak perlu sempurna dari awal, yang penting adalah kemauan untuk terus belajar, berkembang, dan melangkah lebih jauh setiap harinya.',
    },
  ]

  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-[1280px] px-6">
        {/* Section Title */}
        <div className="mb-8 text-center">
          <h2 className="font-['Poppins'] text-2xl font-bold lg:text-3xl">
            <span className="text-[#d91f2e]">Value</span>
            <span className="text-black"> Kami</span>
          </h2>
        </div>

        {/* Values Cards */}
        <div className="flex flex-wrap items-start justify-center gap-6 lg:gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="h-[204px] w-full px-4 pt-3 sm:w-[345px]"
            >
              <h3 className="mb-4 font-['Poppins'] text-xl font-bold text-black">
                {value.title}
              </h3>

              <div className="h-[140px] border-l-2 border-[#d91f2e] pl-5 font-['Poppins'] text-[15px] font-normal leading-5 text-black">
                {typeof value.description === 'string' ? (
                  <p>{value.description}</p>
                ) : (
                  <p>{value.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ValuesSection
